var map = {
	"./cake.webp": 2381,
	"./correct-ico.webp": 2382,
	"./crown-blue.webp": 2383,
	"./crown.webp": 2384,
	"./pocket.webp": 2385,
	"./present.webp": 2386,
	"./relegation.webp": 2387,
	"./t-deposit.webp": 2388,
	"./t-turnover.webp": 2389,
	"./vip-1.webp": 2390,
	"./vip-2.webp": 2391,
	"./vip-3.webp": 2392,
	"./vip-4.webp": 2393,
	"./vip-5.webp": 2394,
	"./vip-badge.webp": 2395,
	"./vip-bg.webp": 2396,
	"./vip-bonus-bg.webp": 2397,
	"./vip1.webp": 2398,
	"./vip2.webp": 2399,
	"./vip3.webp": 2400,
	"./vip4.webp": 2401,
	"./vip5.webp": 2402,
	"./vip6.webp": 2403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;